export const LOGOUT='LOGOUT';
export const LOAD_USER='LOAD_USER';
export const LOAD_SETTING='LOAD_SETTING';

export const AGENT_LOGIN = 'AGENT_LOGIN';
export const AGENT_SEARCH_MSISDN = 'AGENT_SEARCH_MSISDN';
export const AGENT_CLIENT_DETAILS = 'AGENT_CLIENT_DETAILS';
export const AGENT_CLIENT_LOANS = 'AGENT_CLIENT_LOANS';
export const AGENT_CLIENT_TRANSACTIONS = 'AGENT_CLIENT_TRANSACTIONS';
export const AGENT_CLIENT_ERROR = 'AGENT_CLIENT_ERROR';
export const AGENT_LOGOUT = 'AGENT_LOGOUT';
export const AGENT_LOADING = 'AGENT_LOADING';
export const AGENT_CLIENT_PROFILE_LOADING = 'AGENT_CLIENT_PROFILE_LOADING';
export const AGENT_CLIENT_PROFILE = 'AGENT_CLIENT_PROFILE';
export const AGENT_ACTIVE_TAB = 'AGENT_ACTIVE_TAB';

export const AGENT_GET_ALL_USERS = 'AGENT_GET_ALL_USERS';
export const AGENT_CREATE_USERS = 'AGENT_CREATE_USERS';
export const AGENT_EXTEND_DEVICE = 'AGENT_EXTEND_DEVICE';
export const AGENT_EMERGENCY_LOCK_DEVICE = 'AGENT_EMERGENCY_LOCK_DEVICE';
export const AGENT_GET_COMMENTS = 'AGENT_GET_COMMENTS';
export const AGENT_POST_COMMENT = 'AGENT_POST_COMMENT';
export const SELF_LANGUAGE = 'SELF_CARE_LANGUAGE';
export const LANDING_LANGUAGE = 'SET_LANDING_LANGUAGE';

export const CHECK_DEVICE_STATUS = 'CHECK_DEVICE_STATUS';
export const AGENT_CLIENT_PAYMENTS = 'AGENT_CLIENT_PAYMENTS';
